import { BroadcastIds, MessagePayload } from '../types';

export function broadcastSameClientLogout(payload: MessagePayload['payload']) {
  const channel = new BroadcastChannel(BroadcastIds.CHANNEL);
  channel.postMessage({
    id: BroadcastIds.MESSAGE,
    payload,
  } as MessagePayload);

  channel.close();
}
